import Vue from "vue";
// import QuantificationTransformer from "@/transformers/purchase/quantification";
import errorHandler from "@/utils/errorHandler";

export default (payload) => {
  // const transformed = QuantificationTransformer.send(payload);
  const request = errorHandler(
    Vue.$http.post(`/iwarehouse/quantification/re_entry/`, { supplies: payload })
  );
  return request.then((response) => {
    const data = response.data;
    return data;
  });
};


// WEBPACK FOOTER //
// ./src/services/purchase/returnSuppliesAmount.js